import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  listarPrestamos,
  anularPrestamo,
  obtenerPrestamoPorId,
  generarTokenPrestamo
} from '../../api/common';
import Swal from 'sweetalert2';
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Badge,
  Spinner,
  Form,
  InputGroup,
  Dropdown,
  ButtonGroup,
  Modal,
  Collapse
} from 'react-bootstrap';
import {
  FaPlus,
  FaEdit,
  FaFilePdf,
  FaBan,
  FaEye,
  FaSearch,
  FaFilter,
  FaCheckCircle,
  FaBox,
  FaLink,
  FaCopy,
  FaChevronDown,
  FaChevronRight
} from 'react-icons/fa';
import 'jspdf-autotable';
import { descargarPDFPrestamo } from './GenerarPdfPrestamo';
import ModalConfirmarEntrega from './ConfrimarEntrega';

const ListarPrestamos = () => {
  const navigate = useNavigate();
  const [prestamos, setPrestamos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [busquedaInventario, setBusquedaInventario] = useState('');
  const [mostrarModalConfirmar, setMostrarModalConfirmar] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [idPrestamo, setIdPrestamo] = useState(null);

  // Acordeón
  const [openRows, setOpenRows] = useState(new Set());

  // Modal generar link
  const [modalLink, setModalLink] = useState(false);
  const [linkGenerado, setLinkGenerado] = useState('');
  const [generandoLink, setGenerandoLink] = useState(false);
  const [linkCopiado, setLinkCopiado] = useState(false);


  console.log('prestamos cargados:', prestamos);
  useEffect(() => {
    cargarPrestamos();
  }, [refresh]);

  const cargarPrestamos = async () => {
    try {
      setLoading(true);
      const resp = await listarPrestamos();
      
      if (resp.status === 200) {
        setPrestamos(resp.data.data|| []);
      } else {
        Swal.fire('Error', 'No se pudieron cargar los préstamos', 'error');
      }
    } catch (error) {
      console.error('Error al cargar préstamos:', error);
      Swal.fire('Error', 'Ocurrió un error al cargar los préstamos', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Filtrar préstamos
  const prestamosFiltrados = prestamos.filter((prestamo) => {
    // Filtro por estado
    const cumpleEstado =
      filtroEstado === 'todos' || prestamo.estado === filtroEstado;

    // Filtro por búsqueda
    const cumpleBusqueda =
      !busqueda ||
      prestamo.numeroActa?.toLowerCase().includes(busqueda.toLowerCase()) ||
      prestamo.numeroOt?.toLowerCase().includes(busqueda.toLowerCase()) ||
      prestamo.nombreUsuarioCreacion?.toLowerCase().includes(busqueda.toLowerCase());

    // Filtro por inventario de equipo: solo puede existir un préstamo activo
    // por equipo, así que buscar por inventario trae ese préstamo activo.
    const cumpleInventario =
      !busquedaInventario ||
      ((prestamo.estado === 'activo' || prestamo.estado === 'confirmado') &&
        prestamo.equipos?.some((eq) =>
          eq.snapshotEquipo?.inventario
            ?.toLowerCase()
            .includes(busquedaInventario.toLowerCase())
        ));

    return cumpleEstado && cumpleBusqueda && cumpleInventario;
  });

  // Obtener badge de estado
  const getBadgeEstado = (estado) => {
    const estados = {
      activo: { bg: 'warning', text: 'Activo' },
      confirmado: { bg: 'info', text: 'Confirmado' },
      devuelto_parcial: { bg: 'primary', text: 'Dev. Parcial' },
      devuelto: { bg: 'success', text: 'Devuelto' },
      anulado: { bg: 'danger', text: 'Anulado' }
    };

    const config = estados[estado] || { bg: 'secondary', text: estado };
    return <Badge bg={config.bg}>{config.text}</Badge>;
  };

  // Ver detalles
  const handleVerDetalles = (id) => {
    navigate(`/prestamos/detalle/${id}`);
  };

  // Editar préstamo
  const handleEditar = (id) => {
    navigate(`/prestamos/editar/${id}`);
  };

  // Anular préstamo
  const handleAnular = async (prestamo) => {
    const { value: motivo } = await Swal.fire({
      title: '¿Anular préstamo?',
      html: `
        <p>Acta: <strong>${prestamo.numeroActa}</strong></p>
        <p class="text-danger">Esta acción no se puede deshacer.</p>
      `,
      input: 'textarea',
      inputLabel: 'Motivo de anulación',
      inputPlaceholder: 'Ingrese el motivo de la anulación...',
      inputValidator: (value) => {
        if (!value) {
          return 'Debe ingresar un motivo';
        }
      },
      showCancelButton: true,
      confirmButtonText: 'Sí, anular',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#dc3545'
    });

    if (motivo) {
      try {
        const resp = await anularPrestamo(prestamo._id, motivo);
        console.log('Respuesta anular préstamo:', resp);

        if (resp.status === 200) {
          Swal.fire('¡Anulado!', 'El préstamo ha sido anulado', 'success');
          cargarPrestamos();
        } else {
          Swal.fire('Error', resp.message || 'No se pudo anular el préstamo', 'error');
        }
      } catch (error) {
        console.error('Error al anular préstamo:', error);
        Swal.fire('Error', 'Ocurrió un error al anular el préstamo', 'error');
      }
    }
  };

  // Exportar a PDF
  const handleExportarPDF = async (prestamo) => {
    try {
      // Cargar detalles completos
      const resp = await obtenerPrestamoPorId(prestamo._id); 
      
      console.log('Respuesta obtener préstamo por ID:', resp.data);
      if (resp.status !== 200) {
        Swal.fire('Error', 'No se pudo cargar la información del préstamo', 'error');
        return;
      }

      const data = resp.data.data;

      const resultado = descargarPDFPrestamo(data);
      
      if (resultado.ok) {
        Swal.fire('¡Éxito!', resultado.message, 'success');
      } else {
        Swal.fire('Error', resultado.message, 'error');
      }
      
    
    } catch (error) {
      console.error('Error al generar PDF:', error);
      Swal.fire('Error', 'No se pudo generar el PDF', 'error');
    }
  };

  // Recibir equipos
  const handleRecibirEquipos = (id) => {
    navigate(`/prestamos/recibir/${id}`);
  };

  const handleConfirmado = (evento) => {
   console.log('evento recibido en listar prestamos:', evento);    
    setIdPrestamo(evento._id);
    setMostrarModalConfirmar(true);
    setRefresh(!refresh);
  }

  const handleonConfirmado = () => {
    setMostrarModalConfirmar(false);
    setRefresh(!refresh);
  }

  const toggleRow = (id) => {
    setOpenRows(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const handleGenerarLink = async (prestamo) => {
    setGenerandoLink(true);
    setLinkCopiado(false);
    setLinkGenerado('');
    setModalLink(true);
    try {
      const resp = await generarTokenPrestamo(prestamo._id);
      if (resp.status === 200) {
        setLinkGenerado(resp.data.data.linkPublico || '');
      } else {
        Swal.fire('Error', resp.data?.message || 'No se pudo generar el link', 'error');
        setModalLink(false);
      }
    } catch (err) {
      Swal.fire('Error', 'Error al generar el link', 'error');
      setModalLink(false);
    } finally {
      setGenerandoLink(false);
    }
  };

  const handleCopiarLink = () => {
    if (linkGenerado) {
      navigator.clipboard.writeText(linkGenerado).then(() => {
        setLinkCopiado(true);
        setTimeout(() => setLinkCopiado(false), 2500);
      });
    }
  };

  const getBadgeEquipo = (estadoEq) => {
    const map = {
      prestado: { bg: 'warning', label: 'Prestado' },
      devuelto: { bg: 'success', label: 'Devuelto' },
      devuelto_parcial: { bg: 'info', label: 'Dev. Parcial' }
    };
    const cfg = map[estadoEq] || { bg: 'secondary', label: estadoEq };
    return <Badge bg={cfg.bg}>{cfg.label}</Badge>;
  };

  return (
    <Container fluid className="py-4 w-100">
        <ModalConfirmarEntrega
          show={mostrarModalConfirmar}
          onHide={() => setMostrarModalConfirmar(false)}
          otId={''}
          idPrestamo={idPrestamo}
          onConfirmado={() => {
            // Recargar datos de la OT o mostrar mensaje
            handleonConfirmado();
          }}
        />
      {/* Header */}
      <Row className="mb-4">
        <Col>
          <h2 className="mb-0">
            <FaBox className="me-2 text-primary" />
            Préstamos de Equipos
          </h2>
          <p className="text-muted">Gestión de préstamos de equipos patrón</p>
        </Col>
        <Col xs="auto">
          <Button
            variant="primary"
            onClick={() => navigate('/prestamos/crear')}
          >
            <FaPlus className="me-2" />
            Nuevo Préstamo
          </Button>
        </Col>
      </Row>

      {/* Filtros */}
      <Row className="mb-3 g-2">
        <Col md={4}>
          <InputGroup>
            <InputGroup.Text>
              <FaSearch />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Buscar por acta, OT o usuario..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={3}>
          <InputGroup>
            <InputGroup.Text>
              <FaBox />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Buscar por inventario del equipo..."
              value={busquedaInventario}
              onChange={(e) => setBusquedaInventario(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={2}>
          <Form.Select
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
          >
            <option value="todos">Todos los estados</option>
            <option value="activo">Activo</option>
            <option value="confirmado">Confirmado</option>
            <option value="devuelto_parcial">Devolución Parcial</option>
            <option value="devuelto">Devuelto</option>
            <option value="anulado">Anulado</option>
          </Form.Select>
        </Col>
        <Col md={3} className="text-end">
          <Button
            variant="outline-secondary"
            onClick={() => {
              setBusqueda('');
              setBusquedaInventario('');
              setFiltroEstado('todos');
            }}
          >
            <FaFilter className="me-2" />
            Limpiar Filtros
          </Button>
        </Col>
      </Row>

      {/* Tabla */}
      <Card className="shadow-sm mb-4 w-100">
        <Card.Body className="p-0 w-100">
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2">Cargando préstamos...</p>
            </div>
          ) : (
            <Table striped hover responsive className="mb-0">
              <thead className="bg-light">
                <tr>
                  <th>Acta</th>
                  <th>OT</th>
                  <th>Fecha Creación</th>
                  <th>Usuario</th>
                  <th>Equipos</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {prestamosFiltrados.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      <p className="text-muted mb-0">
                        No se encontraron préstamos
                      </p>
                    </td>
                  </tr>
                ) : (
                  prestamosFiltrados.map((prestamo) => (
                    <React.Fragment key={prestamo._id}>
                      {/* Fila principal */}
                      <tr
                        style={{ cursor: 'pointer' }}
                        onClick={() => toggleRow(prestamo._id)}
                      >
                        <td>
                          <span className="me-1" style={{ color: '#6c757d' }}>
                            {openRows.has(prestamo._id) ? <FaChevronDown size={11} /> : <FaChevronRight size={11} />}
                          </span>
                          <strong>{prestamo.numeroActa}</strong>
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          {prestamo.ot?.numeroOrden} - {prestamo.ot?.cliente?.nombre}
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          {new Date(prestamo.fechaCreacion).toLocaleDateString()}
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          {prestamo.usuarioCreacion?.nombre} {prestamo.usuarioCreacion?.apellido}
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <Badge bg="info">{prestamo.equipos?.length || 0}</Badge>
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          {getBadgeEstado(prestamo.estado)}
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <Dropdown as={ButtonGroup} size="sm">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleVerDetalles(prestamo._id)}
                            >
                              <FaEye />
                            </Button>
                            <Dropdown.Toggle split variant="outline-primary" size="sm" />
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => handleEditar(prestamo._id)}
                                disabled={prestamo.estado === 'anulado'}
                              >
                                <FaEdit className="me-2" />
                                Editar
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleConfirmado(prestamo)}
                                disabled={['confirmado','devuelto_parcial','devuelto','anulado'].includes(prestamo.estado)}
                              >
                                <FaCheckCircle className="me-2" />
                                Confirmar Entrega
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleGenerarLink(prestamo)}
                                disabled={['confirmado','devuelto','anulado'].includes(prestamo.estado)}
                              >
                                <FaLink className="me-2" />
                                Generar Link Entrega
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleExportarPDF(prestamo)}
                              >
                                <FaFilePdf className="me-2" />
                                Exportar PDF
                              </Dropdown.Item>
                              {(prestamo.estado === 'confirmado' || prestamo.estado === 'devuelto_parcial') && (
                                <Dropdown.Item
                                  onClick={() => handleRecibirEquipos(prestamo._id)}
                                >
                                  <FaCheckCircle className="me-2" />
                                  Recibir Equipos
                                </Dropdown.Item>
                              )}
                              <Dropdown.Divider />
                              <Dropdown.Item
                                onClick={() => handleAnular(prestamo)}
                                disabled={prestamo.estado === 'anulado' || prestamo.estado === 'devuelto'}
                                className="text-danger"
                              >
                                <FaBan className="me-2" />
                                Anular
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>

                      {/* Fila de detalle acordeón */}
                      {openRows.has(prestamo._id) && (
                        <tr>
                          <td colSpan={7} className="p-0 bg-light">
                            <div className="p-3">
                              <small className="text-muted fw-semibold">EQUIPOS DEL PRÉSTAMO</small>
                              <Table size="sm" bordered className="mt-2 mb-0 bg-white">
                                <thead className="table-secondary">
                                  <tr>
                                    <th>Código / Inventario</th>
                                    <th>Descripción</th>
                                    <th>Serie</th>
                                    <th>Estado</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(prestamo.equipos || []).length === 0 ? (
                                    <tr><td colSpan={4} className="text-center text-muted">Sin equipos</td></tr>
                                  ) : (
                                    (prestamo.equipos || []).map((eq, idx) => (
                                      <tr key={idx}>
                                        <td>{eq.snapshotEquipo?.inventario || eq.codigo || '-'}</td>
                                        <td style={{ whiteSpace: 'normal' }}>{eq.snapshotEquipo?.item || eq.descripcion || '-'}</td>
                                        <td>{eq.snapshotEquipo?.serie || eq.serie || '-'}</td>
                                        <td>{getBadgeEquipo(eq.estado)}</td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
        <Card.Footer className="bg-light w-100">
          <small className="text-muted">
            Mostrando {prestamosFiltrados.length} de {prestamos.length} préstamos
          </small>
        </Card.Footer>
      </Card>

      {/* Modal: Generar Link Público */}
      <Modal show={modalLink} onHide={() => setModalLink(false)} centered size="sm">
        <Modal.Header closeButton className="py-2">
          <Modal.Title className="h6">
            <FaLink className="me-2 text-primary" />
            Link de Entrega
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {generandoLink ? (
            <div className="text-center py-3">
              <Spinner animation="border" variant="primary" size="sm" />
              <p className="mt-2 mb-0 text-muted small">Generando link...</p>
            </div>
          ) : (
            <>
              <p className="small text-muted mb-2">
                Comparte este link con la persona que va a recibir los equipos. Expira en <strong>7 días</strong>.
              </p>
              <Form.Control
                type="text"
                readOnly
                value={linkGenerado}
                className="mb-2"
                style={{ fontSize: '0.78rem' }}
                onClick={(e) => e.target.select()}
              />
              <div className="d-grid">
                <Button
                  variant={linkCopiado ? 'success' : 'primary'}
                  size="sm"
                  onClick={handleCopiarLink}
                >
                  <FaCopy className="me-1" />
                  {linkCopiado ? '¡Copiado!' : 'Copiar Link'}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ListarPrestamos;